import {
  Button,
  LoadingOverlay
} from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import {
  IconCheck,
  IconX
} from "@tabler/icons-react"
import { motion } from "framer-motion"
import { t } from "i18next"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { CollectionQuery } from "../../../models/collection.model"
import { Payment, PaymentStatus } from "../../../models/payment.model"
import Confirmation from "../../../shared/component/confirmation/action-confirmation"
import EmptyIcon from "../../../shared/component/empty-icon/empty-icon"
import FileViewerModal from "../../../shared/component/file-viewer/file-viewer-modal.component"
import { Pagination } from "../../../shared/component/pagination/pagination"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import { dateFormat } from "../../../shared/utility/date-format/date-format"
import { onViewFile } from "../../../shared/utility/view-file"
import { useChangePaymentStatusMutation } from "../../payment/store/payment.query"
import {
  useLazyGetPaymentForLeaseQuery
} from "../store/lease.query"
type NewUnitComponentProps = {
  // lease: any;
  // open: any;
  // opened: boolean;
  // close: any;
}
export function PaymentComponent(props: NewUnitComponentProps) {
  const params = useParams()
  // let { open, opened, close } = props;
  const [opened, { open, close }] = useDisclosure()
  const [userInfo, tenantInfo] = useCurrentUser()
  const [mode, setMode] = useState<"new" | "edit">("new")
  const [type, setType] = useState<"Amount" | "Percent">("Amount")

  const [receipt, setReceipt] = useState<File | null>(null)

  const [paymentCollection, setPaymentCollection] = useState<CollectionQuery>({
    top: 10,
    skip: 0,
    orderBy: [{ field: "createdAt", direction: "desc" }],
  })

  const [getPayments, payments] = useLazyGetPaymentForLeaseQuery()
  const [changeStatus, changeStatusResponse] = useChangePaymentStatusMutation()

  const [fileOpened, { open: fileOpen, close: fileClose }] = useDisclosure()
  const [selectedFile, setSelectedFile] = useState<string[]>([])

  useEffect(() => {
    getPayments({
      ...paymentCollection,
      includes: ["tenant", "lease", "lease.unit", "unit.property", "owner"],
      filter: [
        [{ field: "leaseId", value: params?.id as string, operator: "=" }],
      ],
    })
  }, [getPayments, params.id, paymentCollection])

  return (
    <>
      <div className="bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-lg shadow-lg rounded-xl p-6 border border-gray-700 mb-8">
        <LoadingOverlay visible={payments?.isLoading || payments?.isFetching} />

        <div className="px-2 overflow-x-auto relative">
          <table className="min-w-full divide-y divide-gray-700">
            <thead
            // className="text-xs text-gray-700 capitalize bg-gray-50 dark:bg-gray-700 dark:text-gray-400 "
            >
              <tr className="text-nowrap">
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("amount")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("paymentFrequency")}
                </th>

                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("tenant", { count: 1 })}
                </th>

                {userInfo?.role?.key == "super_admin" && (
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                  >
                    {t("owner", { count: 1 })}
                  </th>
                )}
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("fsNumber")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("paymentProof")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("receipt")}
                </th>
                {/* <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("paymentMethod")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("paymentStatus")}
                </th> */}
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("paymentDate")}
                </th>

                {userInfo?.role?.key !== "tenant" && (
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                    {t("action")}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {payments?.data?.data &&
                payments?.data?.data.length > 0 &&
                payments?.data?.data.map((payment: Payment, idx: number) => (
                  <motion.tr
                    key={idx}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3 }}
                    className="bg-white border-b dark:bg-gray-800 text-xs dark:border-gray-700"
                  >
                    <th className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                      {payment?.amount?.toFixed(2)} ETB
                    </th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                      {payment?.paymentFrequency}
                    </th>
                    {/* <td className="py-4 px-6 text-xs">{document?.referenceNumber}</td> */}

                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                      {payment?.tenant?.name} ({payment?.tenant?.phoneNumber})
                    </td>

                    {userInfo?.role?.key == "super_admin" && (
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {payment?.owner?.name}
                      </td>
                    )}
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {payment?.fsNumber}
                      </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                      {payment?.minioFile && (
                        <span
                          // target="_blank"
                          // rel="noopener noreferrer"
                          // href={tenant?.data?.minoioIdentification}
                          onClick={() => {
                            setSelectedFile([payment?.minioFile as string])
                            fileOpen()
                          }}
                          className=" cursor-pointer  text-white inline-block bg-primary  text-sm px-3 py-1 rounded-full"
                        >
                          {t("view")}
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                      {payment?.receipt && (
                        <span
                          // target="_blank"
                          // rel="noopener noreferrer"
                          // href={tenant?.data?.minoioIdentification}
                          onClick={() => onViewFile(payment?.receipt)}
                          className=" cursor-pointer  text-white inline-block bg-primary  text-sm px-3 py-1 rounded-full"
                        >
                          {t("view")}
                        </span>
                      )}
                    </td>
                    {/* <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {payment?.paymentMethod}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {payment?.paymentStatus}
                      </td> */}

                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                      {payment?.paymentDate ? (
                        <span>
                          {dateFormat(payment?.paymentDate, {
                            weekday: true,
                            day: true,
                            month: true,
                          })}
                        </span>
                      ) : (
                        <span>-</span>
                      )}
                    </td>

                    {userInfo?.role?.key !== "tenant" && (
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        <div className="flex space-x-2">
                          {payment?.paymentStatus == PaymentStatus.Pending && (
                            <div className="flex gap-2">
                              <Confirmation
                                type={"notify"}
                                message={t("approvePaymentMessage")}
                                onYes={() => {
                                  // deleteRentIncrease(payment?.id as string)
                                  const formData = new FormData()

                                  formData.append("id", payment?.id as string)
                                  formData.append(
                                    "status",
                                    PaymentStatus.Success,
                                  )
                                  receipt && formData.append("receipt", receipt)

                                  changeStatus({
                                    id: payment?.id as string,
                                    data: formData,
                                  })
                                  close()
                                }}
                                header={t("approvePaymentTitle")}
                                acceptsFile={
                                  userInfo?.role?.key == "owner" ||
                                  userInfo?.role?.key == "super_admin"
                                }
                                fileLabel={t("receipt")}
                                onAcceptingFile={(file: File) => {
                                  setReceipt(file)
                                }}
                              >
                                <Button
                                  variant="filled"
                                  loading={
                                    changeStatusResponse.isLoading &&
                                    changeStatusResponse?.originalArgs?.id ===
                                      payment?.id
                                  }
                                  className={`bg-green-500 text-white flex space-x-2 items-center`}
                                  type="button"
                                  classNames={{ label: "flex space-x-1" }}
                                  size={"xs"}
                                >
                                  <IconCheck size={20} strokeWidth={1.5} />
                                </Button>
                              </Confirmation>

                              <Confirmation
                                type={"danger"}
                                message={t("permanentDeleteMessage")}
                                onYes={() => {
                                  const formData = new FormData()

                                  formData.append("id", payment?.id as string)
                                  formData.append(
                                    "status",
                                    PaymentStatus.Rejected,
                                  )
                                  // receipt && formData.append('receipt', receipt);

                                  changeStatus({
                                    id: payment?.id as string,
                                    data: formData,
                                  })
                                  // deleteRentIncrease(payment?.id as string)
                                  close()
                                }}
                                header={t("permanentDeleteTitle")}
                              >
                                <Button
                                  variant="filled"
                                  loading={
                                    changeStatusResponse.isLoading &&
                                    changeStatusResponse?.originalArgs?.id ===
                                      payment?.id
                                  }
                                  className={`bg-danger text-white flex space-x-2 items-center`}
                                  type="button"
                                  classNames={{ label: "flex space-x-1" }}
                                  size={"xs"}
                                >
                                  <IconX size={20} strokeWidth={1.5} />
                                </Button>
                              </Confirmation>
                            </div>
                          )}
                        </div>
                      </td>
                    )}
                  </motion.tr>
                ))}
            </tbody>
          </table>
          {!payments?.data?.data?.length ? (
            <div className="w-full relative flex justify-center items-center h-56">
              <EmptyIcon />
            </div>
          ) : (
            <></>
          )}

          {payments?.data && payments?.data?.count > 0 && (
            <div className="w-full flex justify-end items-center mt-2 mb-2">
              <Pagination
                total={payments?.data?.count as number}
                defaultPageSize={10}
                pageSize={[5, 10, 15, 20]}
                onPaginationChange={(skip: number, top: number) => {
                  setPaymentCollection({
                    ...paymentCollection,
                    skip: skip,
                    top: top,
                    includes: ["owner", "tenant", "lease"],

                    filter: [
                      [
                        {
                          field: "leaseId",
                          operator: "=",
                          value: params?.id as string,
                        },
                      ],
                    ],
                  })
                }}
              />
            </div>
          )}
        </div>
      </div>

      <FileViewerModal
        open={fileOpen}
        close={fileClose}
        files={selectedFile}
        opened={fileOpened}
        fileType={t("payment", { count: 1 })}
        fileNames={[]}
        remove={() => {}}
        removeLoading={false}
      />
    </>
  )
}
